import { useEffect, useState } from 'react';
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton, useDialog, Link } from '@albo-ui/core';
import { FileCopyOutlined, NavigateBefore, AccountBox, Edit } from '@mui/icons-material';
import { Box, Divider } from '@mui/material';
import { ManageTask } from '../../modals/leads-crm/ManageTask';
import { CRMCreateRegister } from '../../modals/leads-crm/CRMCreateRegister';
import { CRMUpdateUuid } from '../../modals/leads-crm/CRMUpdateUuid';

import { CRMDescription } from './CRMDescription';
import { useCRMDetail } from './hooks/useCRMDetail';
import { useCRMTask } from './hooks/useCRMTask';
import { CRMLeadProps } from './types';
import { CRMTasks } from './CRMTasks';
import moment from 'moment';
moment.locale('es');

export const CRMLeadDetail = ({ changeAlert, changeLoader, changeWidgets, sectionData: lead, config, crmType, selectedSection, catalogs, platformData, platformInfo, forms, agentList, partnersList, crmContactFlow, segments }: CRMLeadProps) => {
    const dialogProps = useDialog();
    const dialogPropsUuid = useDialog();
    const { theme } = useThemeProvider();
    const [ open, setOpen ] = useState('');
    const [ itemDialog, setItemDialog ] = useState(null);
    const [ itemDialogUuid, setItemDialogUuid ] = useState(null);
    const [ partners, setPartners ] = useState(null);
    
    const { data, loading: loadingData, form, companyGroups, saveData, setData, handleWidgetChange, onUpdateSection, getLeadByUuid, onUpdateUuid } = useCRMDetail(changeAlert, changeWidgets, config);
    const { loading: loadingTask, createTasks } = useCRMTask(changeAlert)
    const [ showMenu, setShowMenu ] = useState(false);
    const copy = (data) => {
        navigator.clipboard.writeText(data);
    };

    const onCloseDialogAction = () => {
        setItemDialog(null);
        dialogProps.onClose();
    };
    const onConfirmAction = (req) => {
        setItemDialog(null);
        dialogProps.onClose();
        createTasks(req);
    };

    
    const onOpenUuidDialog = () => {
        setItemDialogUuid(form);
        dialogPropsUuid.openDialog();
    };
    const onCloseUuidDialog = () => {
        setItemDialogUuid(null);
        dialogPropsUuid.onClose();
    };
    const onConfirmUpdateUuid = (req) => {
        setItemDialogUuid(null);
        dialogPropsUuid.onClose();
        onUpdateUuid(req);
    };

    
    const openMenu = () => {
        setShowMenu(true);
    };
    const closeMenu = () => {
        setShowMenu(false);
    };

    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });

    const hasAction = (action) => {
        return config?.actions?.indexOf(action) > -1;
    };

    const showFields = (value, prop1, prop2, label, select= null) => {
        const getSelected = () => {
            let filter = platformData && platformData[select].filter((item) =>  value === item.key)
            return filter.length > 0 ? filter[0].label : "-"
        }

        const getSegment = () => {
            let filter = segments?.filter((item) =>  value === item.k)
            return filter?.length > 0 ? filter[0].v : "-"
        }

        const getcompanyGroup = () => {
            let filter = companyGroups?.filter((item) =>  value === item.uuid)
            return filter?.length > 0 ? filter[0].group_name : value
        }

        const formatPhoneNumber = (phoneNumberString) => {
            var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
            var match = cleaned.match(/^(\d{1,3}|)?(\d{2})(\d{4})(\d{4})$/);
            if (match) {
                var intlCode = (match[1] ? `+${match[1]} ` : '');
                return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
            }
            return null;
        }

        return (
            <FlexGrid key={`${prop1}-${prop2}`} container>
            <Typography variant="paragraph" color="lightNeutral" style={{width: "70%", paddingRight: 25}}>{label || "No aplica"}</Typography>
            { select ?
                    <Typography variant="paragraph" style={{marginBottom: 4, width: "100%"}}>
                        {getSelected()}
                    </Typography>
                :   prop2.includes('phone') ?
                <Box display={'flex'} width={"100%"} >
                    <Typography variant="paragraph" style={{marginBottom: 4, marginRight: 8}}>
                        {value ? formatPhoneNumber(`${value['phone_code']}${value['phone']}`) : "-"}
                    </Typography>
                </Box>
                :
                prop1 === "revenue" ? 
                    prop2 === "revenue" ? 
                    <Typography variant="smallTitle" style={{marginBottom: 4, width: "100%"}}>{formatter.format((form["revenue"] && (form["revenue"]["nMAB"] || 0) + (form["revenue"]["nMAW"] || 0) + (form["revenue"]["nMAD"] || 0)) || 0)}</Typography>
                    :
                    <Typography variant="paragraph" style={{marginBottom: 4, width: "100%"}}>{formatter.format((value) || 0)}</Typography>
                :
                prop2 === "charge_fee" ? 
                    <Typography variant="paragraph" style={{marginBottom: 4, width: "100%", overflowWrap: "anywhere"}}>
                        {value ? value + " %" : '-'}
                    </Typography>
                :
                prop2 === "segment" ? 
                    <Typography variant="paragraph" style={{marginBottom: 4, width: "100%", overflowWrap: "anywhere"}}>
                        {getSegment()}
                    </Typography>
                :
                prop2 === "company_group" ? 
                    <Typography variant="paragraph" style={{marginBottom: 4, width: "100%", overflowWrap: "anywhere"}}>
                        {getcompanyGroup()}
                    </Typography>
                :
                <Typography variant="paragraph" style={{marginBottom: 4, width: "100%", overflowWrap: "anywhere"}}>
                    {value || '-'}
                </Typography>
            }
            </FlexGrid>
        )
    };

    useEffect(() => {
        setPartners(partnersList || null)
        setData({});
        setItemDialog(null);
        saveData(lead, crmType);
        setOpen(selectedSection === "company" ? "generalCompany" : "generalContact");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lead, selectedSection]);
  
    useEffect(() => {
        changeLoader(loadingData || loadingTask)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingData, loadingTask])

    return (
        <FlexGrid container fullWidth justify='space-between' spacing={2}>
            <Box width={'40%'}>
            
            <Card padding={3} flexDirection='column' fullWidth alignItems='stretch' justifyContent='space-between' style={{ borderColor: theme.colors.manatee, margin: 3, height: "auto" }}> 
                { loadingData ?
                    <Skeleton width='100%' height='100px' />
                    :    
                    <>
                    {platformData && data && <><Box alignItems={'flex-start'} display={'block'}>
                        <Link onClick={() => handleWidgetChange(selectedSection, forms, crmContactFlow)} bold style={{ display: 'flex',  alignItems: 'center', justifyContent: "end" }} typography='smallTitle'>
                            <NavigateBefore style={{ marginRight: 4, marginLeft: -8 }} /> Regresar al Dashboard
                        </Link>
                        <Typography color='primary' variant='h2' style={{display: 'flex', alignItems: 'center', fontSize: '1.2rem'}}>
                            <AccountBox sx={{ marginRight: 1 }}/> 
                            {selectedSection === "company" ? lead[platformData['mainNode']]['company_name'] || "Sin nombre" :
                            (`${lead['general'] && lead['general']['gname']} ${lead['general'] && lead['general']['lname']}`)
                            }
                        </Typography>

                        <Box display={'flex'} alignItems={'center'} justifyContent={'flex-start'}>
                            <Typography variant='paragraph' style={{marginLeft: 33, overflowWrap: 'anywhere'}}>
                            {selectedSection === "company" ? lead[platformData['mainNode']]['onboarding_email'] : lead['general']['email']}
                            </Typography>
                            <FileCopyOutlined titleAccess={`Copiar`} sx={{ml: 1, fontSize: 15}} color='primary' onClick={copy.bind(this, selectedSection === "company" ? lead[platformData['mainNode']]['onboarding_email'] : lead['general']['email'])} cursor={'pointer'} />
                        </Box>
                        </Box>

                        {platformData['sections']?.map((item) => {
                            return data['general'] && item.sectionName.toLowerCase().includes(selectedSection) && <Box key={item.sectionName}>
                            <Divider sx={{my: 2}} />
                            <FlexGrid item style={{paddingBottom: '1rem', display: "flex"}}>
                                <Box display={"flex"} justifyContent={"space-between"}>
                                    <Typography variant='smallTitle' style={{display: 'inline-flex'}}>
                                        {item.title}
                                    </Typography>
                                    <Edit sx={{mr: 1}} onClick={openMenu} color='primary' cursor={'pointer'}/>
                                </Box>
                            </FlexGrid>

                            <FlexGrid item style={{paddingBottom: '0.8rem'}}>
                                {platformInfo?.map((obj) => {
                                    return obj[open] && obj[open]?.map((a) => {
                                        return a['section'] ?
                                        showFields(form[a['section']] && form[a['section']][a['key']], a['section'], a['key'], a['label'], a['catalog'])
                                        :
                                        showFields(form[a['key']], a['section'], a['key'], a['label'], a['catalog'])
                                    })
                                })}
                                <FlexGrid container>
                                    <Typography variant="paragraph" color="lightNeutral" style={{width: "70%", paddingRight: 25, marginBottom: 4}}>Fecha de creación</Typography>
                                    <Typography variant="paragraph" style={{width: "100%"}}>{moment(new Date(form["cdate"])).tz('America/Mexico_City').format('LL')}</Typography>
                                </FlexGrid>
                                {form["sale_owner"] && <FlexGrid container>
                                    <Typography variant="paragraph" color="lightNeutral" style={{width: "70%", paddingRight: 25}}>Origen de venta</Typography>
                                    <Typography variant="paragraph" style={{width: "100%"}}>{form["sale_owner"]["name"]}</Typography>
                                </FlexGrid>}

                                <Divider sx={{my: 3}}/>
                                {
                                    hasAction("crmUpdateUuid") && 
                                    <Box display={"flex"} justifyContent={"end"}>
                                        <Edit sx={{mr: 1}} onClick={onOpenUuidDialog} color='primary' cursor={'pointer'}/> 
                                    </Box>
                                }
                                {form["uuid"] && <FlexGrid container direction='column' style={{marginBottom: 10}}>
                                    <Typography variant="paragraph" color="lightNeutral" style={{display: "flex", paddingRight: 25}}>Deal UUID</Typography>
                                    <Typography variant="paragraph" style={{width: "100%"}}>{form["uuid"]}</Typography>
                                </FlexGrid>}
                                {form["reference_uuid"] && <FlexGrid container direction='column' style={{marginBottom: 10}}>
                                    <Typography variant="paragraph" color="lightNeutral" style={{display: "flex", paddingRight: 25}}>Onboarding UUID</Typography>
                                    <Typography variant="paragraph" style={{width: "100%"}}>{form["reference_uuid"]}</Typography>
                                </FlexGrid>}
                                {form["customer_uuid"] && <FlexGrid container direction='column'>
                                    <Typography variant="paragraph" color="lightNeutral" style={{display: "flex", paddingRight: 25}}>Customer UUID</Typography>
                                    <Typography variant="paragraph" style={{width: "100%"}}>{form["customer_uuid"]}</Typography>
                                </FlexGrid>}
                            </FlexGrid>
                            </Box>
                        })}
                    </>
                    }
                </>
                }
            </Card>

            <CRMTasks
                changeAlert={changeAlert}
                changeLoader={changeLoader}
                changeWidgets={changeWidgets}
                config={config}
                sectionData={lead}
                item={itemDialog}
                pplTab={"meet"}
            />
            </Box>

            <Box width={'60%'}>
                { data &&
                    <CRMDescription
                        changeAlert={changeAlert}
                        changeLoader={changeLoader}
                        changeWidgets={changeWidgets}
                        config={config}
                        section={selectedSection}
                        lead={data}
                        platformData={platformData}
                        platformInfo={platformInfo}
                        catalogs={catalogs}
                        crmType={crmType}
                        getLeadByUuid={getLeadByUuid}
                        agentList={agentList}
                        partnerList={partners}
                    />
                }
                <CRMTasks
                    changeAlert={changeAlert}
                    changeLoader={changeLoader}
                    changeWidgets={changeWidgets}
                    config={config}
                    sectionData={lead}
                    item={itemDialog}
                    pplTab={"task"}
                />
            </Box>
        
            <ManageTask
                item={itemDialog}
                open={dialogProps.open}
                onClose={onCloseDialogAction}
                onConfirm={onConfirmAction}
            />

            <CRMCreateRegister 
                changeAlert={changeAlert}
                changeLoader={changeLoader}
                config={config}
                sectionData={form}
                formSelected={selectedSection === 'company' ? platformData && platformInfo[1][platformData['createCompany']] : platformData && platformInfo[0][platformData['createContact']]}
                platformData={platformData}
                platformInfo={platformInfo}
                selectedSection={selectedSection}
                open={showMenu}
                onClose={closeMenu}
                catalogs={catalogs}
                getData={onUpdateSection.bind(this, selectedSection)}
                crmType={crmType}
                getLeadByUuid={getLeadByUuid}
                companyGroups={companyGroups}
                segments={segments}
            />

            <CRMUpdateUuid
                data={itemDialogUuid}
                open={dialogPropsUuid.open}
                onClose={onCloseUuidDialog}
                onConfirm={onConfirmUpdateUuid}
            />
        </FlexGrid>
    );
};
